import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../../api';

const addVaucherToBasket = async ({ createdBy, productId, price }) => {
  console.group('[addVaucherToBasket] start');
  console.log('INPUT:', { createdBy, productId, price });

  const pid = productId;

  // Проверка существования подарочной карты по id
  const { data: giftCard, error: giftError } = await supabase
    .from('gift_cards')
    .select('id')
    .eq('id', pid)
    .maybeSingle();

  console.log('[GIFT CARD CHECK] data:', giftCard, 'error:', giftError);
  if (giftError) {
    console.error('[GIFT CARD CHECK] error object:', giftError);
    console.groupEnd();
    throw new Error(`Gift card check failed: ${giftError.message || giftError}`);
  }
  if (!giftCard) {
    console.warn('[GIFT CARD CHECK] not found or already removed:', pid);
    console.groupEnd();
    throw new Error(`Gift card ${pid} not found or already redeemed`);
  }

  // Получаем текущий pending заказ или создаём новый
  const { data: ordersData, error: orderCheckError } = await supabase
    .from('orders')
    .select('id, created_at')
    .eq('created_by', createdBy)
    .eq('status', 'Pending')
    .order('created_at', { ascending: false })
    .limit(1);

  console.log('[CHECK ORDER] data:', ordersData, 'error:', orderCheckError);
  if (orderCheckError) {
    console.error('[CHECK ORDER] error object:', orderCheckError);
    console.groupEnd();
    throw new Error(`Order lookup failed: ${orderCheckError.message || orderCheckError}`);
  }

  let orderId = ordersData?.[0]?.id;
  
 
if (orderId) {
  console.log('[CLEAR ORDER ITEMS] deleting all items for order', orderId);
  const { error: deleteError } = await supabase
    .from('order_items')
    .delete()
    .eq('order_id', orderId);

  if (deleteError) {
    console.error('[CLEAR ORDER ITEMS] error:', deleteError);
    console.groupEnd();
    throw new Error(`Failed to clear order items: ${deleteError.message || deleteError}`);
  }
}


  if (!orderId) {
    const { data: newOrder, error: orderError } = await supabase
      .from('orders')
      .insert([{ status: 'Pending', created_by: createdBy }])
      .select('id')
      .single();

    console.log('[CREATE ORDER] data:', newOrder, 'error:', orderError);
    if (orderError || !newOrder?.id) {
      console.error('[CREATE ORDER] failed:', orderError);
      console.groupEnd();
      throw new Error(`Order creation failed: ${orderError?.message || 'No order ID returned'}`);
    }
    orderId = newOrder.id;
  }

  // Проверяем, есть ли уже этот item в заказе
  const { data: existingItem, error: itemCheckError } = await supabase
    .from('order_items')
    .select('*')
    .eq('order_id', orderId)
    .eq('gift_card_id', pid)
    .maybeSingle();

  console.log('[CHECK ITEM] data:', existingItem, 'error:', itemCheckError);
  if (itemCheckError) {
    console.error('[CHECK ITEM] error object:', itemCheckError);
    console.groupEnd();
    throw new Error(`Order item check failed: ${itemCheckError.message || itemCheckError}`);
  }
  if (existingItem) {
    console.log('[ITEM EXISTS] returning existing item');
    console.groupEnd();
    return { orderId, orderItemData: existingItem };
  }

  // Вставляем новый item
  console.log('[CREATE ITEM] inserting:', { order_id: orderId, gift_card_id: pid, price });
  const { data: orderItemData, error: orderItemError } = await supabase
    .from('order_items')
    .insert([{ order_id: orderId, gift_card_id: pid, price }])
    .select()
    .single();

  console.log('[CREATE ITEM] result:', orderItemData, 'error:', orderItemError);
  if (orderItemError) {
    if (orderItemError.code === '23503') {
      console.error('[CREATE ITEM] FK error (gift_card missing):', orderItemError);
      console.groupEnd();
      throw new Error('Cannot add voucher: gift card not found or already removed');
    }
    console.error('[CREATE ITEM] other error:', orderItemError);
    console.groupEnd();
    throw new Error(`Order item creation failed: ${orderItemError.message || orderItemError}`);
  }

  console.log('[RESULT]', { orderId, orderItemData });
  console.groupEnd();
  return { orderId, orderItemData };
};

export default function useAddVaucherToBasket() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addVaucherToBasket,
    onSuccess: () => {
      console.log('[MUTATION SUCCESS] invalidating queries');
      queryClient.invalidateQueries(['useGetOrdersInTheCart']);
      queryClient.invalidateQueries(['useGetOrders']);
    },
    onError: (error) => {
      console.error('[MUTATION ERROR]', error);
    },
  });
}
